import { styled } from '@mui/material';
import { ReactQueryDevtools as Devtools } from '@tanstack/react-query-devtools';
import { useChatbot } from '../chatbot/useChatbot';

const FixedContainer = styled('div')(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(10),
  padding: '1px',
  zIndex: 1200,
}));

export const ReactQueryDevtools = () => {
  const { isAvailable: viewChatbot, isOpen: chatbotOpen } = useChatbot();

  if (viewChatbot && !chatbotOpen) {
    return (
      <FixedContainer>
        <Devtools initialIsOpen={false} buttonPosition="relative" />
      </FixedContainer>
    );
  }

  if (chatbotOpen) {
    return <Devtools initialIsOpen={false} buttonPosition="bottom-left" />;
  }

  return <Devtools initialIsOpen={false} buttonPosition="bottom-right" />;
};
